import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import SimBillingTabsView from "../../../../../views/activationSales/components/simBilling/simBillingTabsView";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { getJCJPIDs } from "../../../../../utils/common/index";
import { ExportToCsv } from "export-to-csv";
import { simBillingCsvFilter } from "../../../../../utils/common/csvMappings/simBillingCsv";
import {
  fetchShowAlertActivation,
  hideAlertActivation,
} from "../../../../../redux/actions/activationSales";

const SimBillingTabs = (props) => {
  const dispatch = useDispatch();

  let {
    url,
    csvEndPointUrl,
    /*isCsvActive,*/ triggerFetchSimBilling,
    triggerFetchSimBillingCsv,
    section,
    moduleName,
    other: { filterValue, headerSelectedDateFrom, headerSelectedDateTo },
  } = props;

  // console.log("inside", url)

  const { simBillingObj, actCsvLoading } = useSelector(
    (state) => state.activationSalesReducer
  );

  let { level, jioPointId, partnerRT, retailerId } = getJCJPIDs(filterValue);

  const data = {
    id: filterValue.orgId
      ? filterValue.orgId
      : filterValue.selectedRole.split(" - ")[2],
    partnerRoleType: partnerRT,
    fromDate: headerSelectedDateFrom,
    toDate: headerSelectedDateTo,
    section: props.section,
    moduleName: props.moduleName,
    jioPointId: jioPointId,
    retailerId: retailerId,
    level: level,
    jprTypeName:
      filterValue.selectedCategory && filterValue.selectedCategory !== "ALL"
        ? filterValue.selectedCategory
        : "",
  };

  useEffect(() => {
    function fetchData() {
      const obj = {
        headers: {
          "Content-Type": "application/json",
          url: url,
        },
        params: data,
        extraData: url,
      };

      return dispatch(triggerFetchSimBilling(obj));
    }

    if (
      !(
        partnerRT === "ZDMT" &&
        props &&
        props.tileName.split(" ")[0] === "Sell"
      ) &&
      url === "/activation-sim-billing-primary" &&
      simBillingObj &&
      simBillingObj?.simBillingData &&
      simBillingObj?.simBillingData?.simBillingPrimary?.loading === false
    ) {
      fetchData();
    } else if (
      !(
        partnerRT === "ZDMT" &&
        props &&
        props.tileName.split(" ")[0] === "Sell"
      ) &&
      url === "/activation-sim-billing-secondary" &&
      simBillingObj &&
      simBillingObj?.simBillingData &&
      simBillingObj.simBillingData?.simBillingSecondary?.loading === false
    ) {
      fetchData();
    } else if (
      !(
        partnerRT === "ZDMT" &&
        props &&
        props.tileName.split(" ")[0] === "Sell"
      ) &&
      url === "/activation-sim-billing-tertiary" &&
      simBillingObj &&
      simBillingObj?.simBillingData &&
      simBillingObj?.simBillingData?.simBillingTertiary?.loading === false
    ) {
      fetchData();
    }

    // if (
    //   !(partnerRT ==="ZDMT" && props && props.tileName.split(" ")[0] === "Sell") &&
    //   simBillingObj &&
    //   simBillingObj.simBillingData &&
    //   simBillingObj.simBillingData[url] === undefined &&
    //   (simBillingObj.error === null || simBillingObj.error[url] === undefined)
    // ) {
    //   fetchData();
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerSelectedDateFrom, headerSelectedDateTo]);

  function fetchCsvData(tab) {
    // setDownloadCsv(true);
    const obj = {
      headers: {
        "Content-Type": "application/json",
        url: csvEndPointUrl,
      },
      params: data,
      extraData: csvEndPointUrl,
      tab,
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: "SimBilling",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    let csvExporter = new ExportToCsv(options);
    return dispatch(
      triggerFetchSimBillingCsv(obj, (response, params) => {
        if (response?.content?.length) {
          const role =
            props.other.filterValue.selectedJC === ""
              ? props.other.filterValue.selectedPartnerRoleName
              : props.other.filterValue.selectedJC === "ALL"
              ? props.other.filterValue.selectedPartnerRoleName
              : "JP";
          const tile = props.tileName.split(" ")[0];
          let csvData = response.content;
          try {
            const filtered = simBillingCsvFilter(
              role,
              tile,
              response.content
            );
            if (filtered?.length) {
              csvData = filtered;
            }
          } catch (err) {
            // Keep raw API rows so download still works if role/tile mapping is missing
            csvData = response.content;
          }
          csvExporter.generateCsv(csvData);
        } else {
          dispatch(fetchShowAlertActivation());
          setTimeout(() => {
            dispatch(hideAlertActivation());
          }, 5000);
        }
      })
    );
  }

  const timestamp =
    props.timeStampArr &&
    props.timeStampArr.filter((row) => row.tilename === props.tileName);

  return (
    <SimBillingTabsView
      timestamp={timestamp}
      fetchCsvData={fetchCsvData}
      simBillingObj={simBillingObj}
      url={url}
      partnerRT={partnerRT}
      tileName={props.tileName}
      csvEndPointUrl={props.csvEndPointUrl}
      csvName={props.csvName}
      isCsvActive={props.isCsvActive}
      index={props.index}
      headerSelectedDateFrom={headerSelectedDateFrom}
      headerSelectedDateTo={headerSelectedDateTo}
      actCsvLoading={actCsvLoading}
      moduleName={moduleName}
      section={section}
    />
  );
};

SimBillingTabs.propTypes = {
  url: PropTypes.string,
  csvEndPointUrl: PropTypes.string,
  isCsvActive: PropTypes.string,
  filterValue: PropTypes.object,
  headerSelectedDateFrom: PropTypes.string,
  headerSelectedDateTo: PropTypes.string,
  triggerSimActivationAPI: PropTypes.func,
  triggerSimActivationCsvAPI: PropTypes.func,
};

export default SimBillingTabs;

